import script from "./StaffDatatableFormCustomRole.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDatatableFormCustomRole.vue?vue&type=script&setup=true&lang=js"

import "./StaffDatatableFormCustomRole.vue?vue&type=style&index=0&id=6aacde28&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aacde28"]])

export default __exports__